export const SHOW_BASIC_MODAL = 'ui/SHOW_BASIC_MODAL'
